import { Tooltip } from '@material-tailwind/react';
import { tooltipPlacement, tooltipSize } from '../utils/enums';
import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@ui/atoms/utils/utils';
import { Text, Image } from '@ui/atoms/index';

const tooltipVariants = cva(
    'absolute bg-basicWhite shadow-md rounded-lg z-[999] mobile:max-w-[312px] mobile:w-max text-basicBlack p4-regular transition-opacity duration-300 ease-in-out border border-gray-50',
    {
        variants: {
            size: {
                small: 'px-3 py-2.5 ',
                regular: 'px-4 py-3 ',
            },
        },
        defaultVariants: {
            size: tooltipSize.SMALL,
        },
    }
);

const ToolTip = React.forwardRef(
    (
        {
            children,
            content, // Custom content inside the tooltip
            placement = tooltipPlacement.BOTTOM_START, // Tooltip placement ('top', 'bottom', 'left', 'right')
            offset = {
                mainAxis: 0,
                crossAxis: 0,
            },
            size = tooltipSize.SMALL, // Tooltip size ('small' or 'regular')
            title, // Optional title within tooltip content
            description, // Optional description within tooltip content
            interactive = true, // Whether the tooltip is interactive, which allows for links and buttons inside the tooltip
            className = '', // Extra classes for outer wrapper
            tooltipWrapperClass = '', // Extra classes for tooltip wrapper
            ...props
        },
        ref
    ) => {
        return (
            <div
                ref={ref}
                className={`z-0 relative flex items-center ${className}`}
            >
                {children}
                <Tooltip
                    placement={placement}
                    className={cn(
                        tooltipVariants({
                            size,
                            tooltipWrapperClass,
                        })
                    )}
                    interactive={interactive}
                    content={
                        content ? (
                            content
                        ) : (
                            <div
                                className={cn('flex flex-col gap-1', {
                                    'gap-0.5': size === tooltipSize.SMALL,
                                })}
                            >
                                {title && (
                                    <Text
                                        content={title}
                                        className={cn(
                                            'text-basicBlack p4-medium',
                                            {
                                                'p5-medium':
                                                    size === tooltipSize.SMALL,
                                            }
                                        )}
                                    />
                                )}
                                {description && (
                                    <Text
                                        content={description}
                                        className={cn(
                                            'text-basicBlack p4-regular ',
                                            {
                                                'p5-regular':
                                                    size === tooltipSize.SMALL,
                                            }
                                        )}
                                        isInnerHtml={props.isInnerHtml || false}
                                    />
                                )}
                            </div>
                        )
                    }
                    {...props}
                >
                    <div className="relative flex items-center w-4 h-4">
                        <Image src="/images/info-new.svg" className="ml-1" />
                    </div>
                </Tooltip>
            </div>
        );
    }
);

export default ToolTip;

//Example usage:
// import ToolTip from '@components/ToolTip';
// import { tooltipPlacement, tooltipSize } from '@components/utils/enums';

// function ExampleComponent() {
//     return (
//         <div className="flex items-center justify-center h-screen">
//             <ToolTip
//                 title="Information"
//                 description="This button performs a specific action."
//                 placement={tooltipPlacement.TOP}
//                 size={tooltipSize.REGULAR}
//             >
//                 <button className="p-3 text-white bg-blue-500 rounded-md">
//                     Hover me
//                 </button>
//             </ToolTip>
//         </div>
//     );
// }

// export default ExampleComponent;
